import { render, staticRenderFns } from "./CustomerBalanceReport.html?vue&type=template&id=3647fbd8&scoped=true&external"
import script from "./CustomerBalanceReport.js?vue&type=script&lang=js&external"
export * from "./CustomerBalanceReport.js?vue&type=script&lang=js&external"
import style0 from "./CustomerBalanceReport.scss?vue&type=style&index=0&id=3647fbd8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3647fbd8",
  null
  
)

export default component.exports